export default __webpack_public_path__ + "static/brand-441abee6af29e728586563f08d6ddba7.png";